import cn from 'classnames'
import { selectCountries } from 'legacy/lut/selectors/app'
import { memo, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { DropdownDynamic } from 'core-components/library/dropdown'
import { Tooltip } from 'core-components/library/tooltip'
import { Static } from 'core-components/types'
import { ICountry } from 'core/classes/models/IReference'
import { Crud } from 'core/types/Crud'

import {
  FIELD_FOR_SEARCH,
  PHONE_CODE_FIELD,
  PHONE_CODE_LABEL,
  PHONE_CODE_PAGING,
  PHONE_CODE_SORT,
} from '../../configs'

import { calculatePhoneCodeCaption } from './helpers/calculatePhoneCodeCaption'
import { renderPhoneCodeFn } from './helpers/renderPhoneCodeFn'
import { IPhoneCodeInputProps } from './models'

import styles from './PhoneCodeInput.module.scss'

export const PhoneCodeInput = memo<IPhoneCodeInputProps>(
  ({ classes, checkFn, isDisabled, onBlur, onChange, errorMessage, value }) => {
    const appCountries = useSelector(selectCountries)
    const countrySource = useMemo(
      () =>
        new Crud({
          fetcher: new Static(appCountries),
          keyField: PHONE_CODE_FIELD,
          defaultPaging: PHONE_CODE_PAGING,
          defaultSort: PHONE_CODE_SORT,
        }),
      [appCountries]
    )

    const handlePhoneCodeChange = useCallback(
      (value: string, item: ICountry) => {
        onChange(value, item)
      },
      [onChange]
    )

    const renderTipContent = useCallback(() => <>{errorMessage}</>, [errorMessage])

    return (
      <Tooltip disabled={!errorMessage} tipContent={renderTipContent}>
        <DropdownDynamic
          disabled={isDisabled}
          classes={{
            ...classes,
            controlClasses: {
              ...classes?.controlClasses,
              root: cn(classes?.controlClasses?.root, styles.phoneCodeInput, {
                [styles.invalid]: errorMessage,
              }),
            },
            inputClasses: {
              ...classes?.inputClasses,
              root: cn(styles.phoneCodeInput, classes?.inputClasses?.root),
            },
          }}
          label={PHONE_CODE_LABEL}
          source={countrySource}
          onBlur={onBlur}
          onChange={handlePhoneCodeChange}
          value={value}
          renderFunction={renderPhoneCodeFn}
          fieldsToSearch={FIELD_FOR_SEARCH}
          calculateCaption={calculatePhoneCodeCaption}
          checkFn={checkFn}
        />
      </Tooltip>
    )
  }
)
